var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductIconCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6,13l-1.42-4H1",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40,13l1.23-3.99h2.77",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.56,13.05l13.57-.04h3.09c1.51-.01,2.75,1.14,2.75,2.58l.04,15.29c0,1.12-.94,2.03-2.12,2.03h-4.31c-1.18,0-2.13-.9-2.14-2.01v-4.05s-10.87.01-10.87.01l-3.88.03h-10.08s.02,4.07.02,4.07c0,1.11-.95,2.02-2.13,2.02h-4.31c-1.18.01-2.13-.89-2.14-2l-.05-15.29c0-1.44,1.22-2.6,2.74-2.61h3.09l12.86-.04h3.87Z",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7,20h7",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33,20h7",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m39,12.93l-3.84-10.27c-.18-.49-.52-.91-.96-1.21s-.96-.46-1.5-.46l-18.46.04c-.54,0-1.06.16-1.5.46-.44.3-.77.72-.95,1.21l-3.79,10.29",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIconCar);
export default __webpack_public_path__ + "static/media/product-icon-car.6f940e720afb558c2dec06d4144655b6.svg";
export { ForwardRef as ReactComponent };